export default {
    COMPRADOR: {
        SET_ANALISE_DOCUMENTOS_DO_FORNECEDOR: 'setAnaliseDocumentosDoFornecedor',
        SET_ATUALIZAR_ANALISE_DE_DOCUMENTO: 'setAtualizarAnaliseDeDocumento',
        SET_ASSINATURA_SOLICITADA_DOCUMENTO_APRESENTADO: 'setAssinaturaSolicitadaDocumentoApresentado',
        SET_ASSINATURA_SOLICITADA_REAJUSTE_PROPOSTA: 'setAssinaturaSolicitadaReajusteProposta',
        SET_AUTOCOMPLETE_IMPORTAR_COMPRA_DIRETA: 'setAutocompleteImportarCompraDireta',
        SET_DADOS_ACOMPANHAMENTO: 'setDadosAcompanhamentoDoComprador',
        SET_FILTROS_BUSCA_COMPRA_DIRETA_EM_ANDAMENTO: 'setFiltrosBuscaCompraDiretaEmAndamentoDoComprador',
        SET_FILTROS_BUSCA_COMPRA_DIRETA_EM_ELABORACAO: 'setFiltrosBuscaCompraDiretaEmElaboracaoDoComprador',
        SET_FILTROS_BUSCA_COMPRA_DIRETA_ENCERRADA: 'setFiltrosBuscaCompraDiretaEncerradaDoComprador',
        SET_FILTROS_BUSCA_TODAS_COMPRAS_DIRETAS: 'setFiltrosBuscaTodasComprasDiretasDoComprador',
        SET_FILTROS_BUSCA_AVANCADA_COMPRAS_DIRETAS_COMPRADOR: 'setFiltrosBuscaAvancadaComprasDiretasDoComprador',
        SET_PAGINACAO_BUSCA_COMPRA_DIRETA_EM_ANDAMENTO: 'setPaginacaoBuscaCompraDiretaEmAndamentoDoComprador',
        SET_PAGINACAO_BUSCA_COMPRA_DIRETA_EM_ELABORACAO: 'setPaginacaoBuscaCompraDiretaEmElaboracaoDoComprador',
        SET_PAGINACAO_BUSCA_COMPRA_DIRETA_ENCERRADA: 'setPaginacaoBuscaCompraDiretaEncerradaDoComprador',
        SET_PAGINACAO_BUSCA_TODAS_COMPRAS_DIRETAS: 'setPaginacaoBuscaTodasComprasDiretasDoComprador',
        SET_PAGINACAO_BUSCA_AVANCADA_COMPRAS_DIRETAS_COMPRADOR: 'setPaginacaoBuscaAvancadaComprasDiretasDoComprador',
        SET_RESULTADO_ATUALIZAR_DADOS_DA_COMPRA_DIRETA: 'setResultadoAtualizarDadosDaCompraDiretaDoComprador',
        SET_RESULTADO_ITENS_E_LOTES: 'setResultadoItensELotes',
        SET_SITUACAO_NEGOCIACAO: 'setSituacaoNegociacao',
        SET_SITUACAO_REAJUSTE_DE_PROPOSTAS: 'setSituacaoReajustePropostas',
        SET_SITUACAO_RANKING_EM_ANALISE: 'setSituacaoAdjudicado',
        SET_FILTROS_BUSCA_REQUISICOES_POR_SISTEMA: 'setFiltrosBuscaRequisicoesPorSistema',
        SET_PAGINACAO_BUSCA_REQUISICOES_POR_SISTEMA: 'setPaginacaoBuscaRequisicoesPorSistema',
        SET_FILTROS_BUSCA_COMPRAS_LEGADAS: 'setFiltrosBuscaComprasLegadas',
        SET_DOCUMENTO_DESENTRANHAMENTO: 'setDocumentoDesentranhamento'
    },
    FORNECEDOR: {
        SET_ATUALIZAR_DOCUMENTO_SOLICITADO_DA_PROPOSTA: 'setAtualizarDocumentoSolicitadoDaProposta',
        SET_ATUALIZAR_TODOS_DOCUMENTOS_SOLICITADOS_DA_PROPOSTA: 'setAtualizarTodosDocumentosSolicitadosDaProposta',
        SET_ATUALIZAR_ITEM_E_LOTE_DA_PROPOSTA: 'setAtualizarItemELoteDaProposta',
        SET_ATUALIZAR_ITEM_E_LOTE_DO_REAJUSTE: 'setAtualizarItemELoteDoReajusteDoFornecedor',
        SET_ATUALIZAR_MEU_ULTIMO_LANCE: 'setAtualizarMeuUltimoLance',
        SET_DOCUMENTOS_SOLICITADOS_DA_PROPOSTA: 'setDocumentosSolicitadosDaProposta',
        SET_FILTROS_BUSCA_MINHAS_COMPRAS_DIRETAS: 'setFiltrosBuscaMinhasComprasDiretas',
        SET_FILTROS_BUSCA_AVANCADA_COMPRAS_DIRETAS_FORNECEDOR: 'setFiltrosBuscaAvancadaComprasDiretasFornecedor',
        SET_FILTROS_BUSCA_COMPRAS_DIRETAS_DISPONIVEIS: 'setFiltrosBuscaComprasDisponiveis',
        SET_FILTROS_BUSCA_COMPRA_DIRETA_ENCERRADA: 'setFiltrosBuscaCompraDiretaEncerradaDoFornecedor',
        SET_FILTROS_BUSCA_MEU_INTERESSE_COMPRAS_DIRETAS: 'setFiltrosBuscaMeuInteresseComprasDiretas',
        SET_ITENS_E_LOTES_DA_PROPOSTA: 'setItensELotesDaPropostaDoFornecedor',
        SET_ITENS_E_LOTES_VENCEDORES: 'setItensELotesVencedores',
        SET_LANCES_DA_COMPRA_DIRETA: 'setLancesDaCompraDireta',
        SET_ITENS_E_LOTES_VENCEDORES_A_REAJUSTAR: 'setMeusItensELotesVencedoresAReajustar',
        SET_MEUS_LOTES_E_ITENS_VENCEDORES: 'setMeusLotesEItensVencedores',
        SET_NOVO_ESTADO_DE_ACEITE_NEGOCIACAO_REAJUSTE: 'setNovoEstadoDeAceiteNegociacaoReajuste',
        SET_NOVO_VALOR_INSERIDO_PARA_LANCE: 'setNovoValorInseridoParaLance',
        SET_PAGINACAO_BUSCA_COMPRAS_DIRETAS_DISPONIVEIS: 'setPaginacaoBuscaCompraDiretaDisponiveis',
        SET_PAGINACAO_BUSCA_COMPRA_DIRETA_ENCERRADA: 'setPaginacaoBuscaCompraDiretaEncerradaDoFornecedor',
        SET_PAGINACAO_BUSCA_MINHAS_COMPRAS_DIRETAS: 'setPaginacaoBuscaMinhasComprasDiretas',
        SET_PAGINACAO_BUSCA_AVANCADA_COMPRAS_DIRETAS_FORNECEDOR: 'setPaginacaoBuscaAvancadaComprasDiretasFornecedor',
        SET_PAGINACAO_BUSCA_MEU_INTERESSE_COMPRAS_DIRETAS: 'setPaginacaoBuscaMeuInteresseComprasDiretas',
        SET_QUANTIDADE_DE_CASAS_DECIMAIS_DA_COMPRA_DIRETA: 'setQuantidadeDeCasasDecimaisDaCompraDiretaDoFornecedor',
        SET_RESULTADO_DE_TODOS_LOTES_E_ITENS: 'setResultadoDeTodosLotesEItensDoFornecedor',
        SET_RESUMO_DA_COMPRA_DIRETA_NA_PROPOSTA: 'setResumoDaCompraDiretaNaProposta',
        SET_TERMOS: 'setTermosDoFornecedor',
        SET_VERIFICAR_SE_POSSUI_LOTE_ITEM_VENCEDOR: 'setVerificarSePossuiLoteItemVencedor'
    },
    LOKI: {
        DISABLE_GLOBAL_LOADING: 'disableGlobalLoading',
        ENABLE_GLOBAL_LOADING: 'enableGlobalLoading',
        SET_GLOBAL_LOADING: 'setGlobalLoading',
        SET_LOADING_MESSAGE: 'setLoadingMessage',
        SET_NOTIFICATION: 'setNotification',
        SET_TIMEZONE: 'setTimezone',
        SHOW_ALERT: 'showAlert',
        SET_NOTIFICACOES: 'setNotificacoes',
        SET_NOTIFICACOES_NAO_LIDAS: 'setnotificacoesNaoLidas'
    },
    SET_ADICIONAR_DOCUMENTO_SOLICITADO: 'setAdicionarDocumentoSolicitado',
    SET_ADICIONAR_EMAIL_CONVIDADO: 'setAdicionarEmailConvidado',
    SET_ADICIONAR_LINHA_DE_FORNECIMENTO: 'setAdicionarLinhaDeFornecimento',
    SET_ADICIONAR_ANEXO_DADOS_GERAIS: 'setAdicionarAnexoDadosGerais',
    SET_ALTERAR_EXCLUSIVIDADE_ITEM: 'setAlterarExclusividadeItem',
    SET_ALTERAR_EXCLUSIVIDADE_LOTE: 'setAlterarExclusividadeLote',
    SET_ATUALIZAR_DOCUMENTO_SOLICITADO: 'setAtualizarDocumentoSolicitado',
    SET_FILTROS_BUSCA_COMPRA_DIRETA: 'setFiltrosBuscaCompraDireta',
    SET_COMPRA_DIRETA: 'setCompraDireta',
    SET_CONVIDADOS_DA_COMPRA_DIRETA: 'setConvidadosDaCompraDireta',
    SET_DADOS_GERAIS: 'setDadosGerais',
    SET_DESABILITAR_SALVAMENTO_AUTOMATICO: 'setDesabilitarSalvamentoAutomatico',
    SET_DOCUMENTOS: 'setDocumentos',
    SET_DOCUMENTOS_PROPOSTA: 'setDocumentosProposta',
    SET_DOCUMENTOS_SOLICITADOS: 'setDocumentosSolicitados',
    SET_EXPANDIR_MENU: 'setExpandirMenu',
    SET_HABILITAR_SALVAMENTO_AUTOMATICO: 'setHabilitarSalvamentoAutomatico',
    SET_LINGUAGEM: 'setLinguagem',
    SET_LINHAS_DE_FORNECIMENTO: 'setLinhasDeFornecimento',
    SET_LINHAS_DE_FORNECIMENTO_DA_COMPRA_DIRETA: 'setLinhasDeFornecimentoDaCompraDireta',
    SET_LINK_ARQUIVO: 'setLinkArquivo',
    SET_MENU_AVATAR: 'setMenuAvatar',
    SET_ITENS_E_LOTES: 'setItensELotes',
    SET_PAGINACAO_BUSCA_COMPRA_DIRETA: 'setPaginacaoBuscaCompraDireta',
    SET_PARAMETROS: 'setParametros',
    SET_PERFIS: 'setPerfis',
    SET_PRODUTO: 'setProduto',
    SET_REMOVER_ANEXO_DADOS_GERAIS: 'setRemoverAnexoDadosGerais',
    SET_REMOVER_DOCUMENTO_SOLICITADO: 'setRemoverDocumentoSolicitado',
    SET_REMOVER_EMAIL_CONVIDADO: 'setRemoverEmailConvidado',
    SET_REMOVER_ITEM: 'setRemoverItem',
    SET_REMOVER_LOTE: 'setRemoverLote',
    SET_REMOVER_LINHA_FORNECIMENTO: 'setRemoverLinhaFornecimento',
    SET_RESUMO_DA_COMPRA_DIRETA: 'setResumoDaCompraDireta',
    SET_RESUMO_ITEM_E_LOTE: 'setResumoItemELote',
    SET_RETRAIR_MENU: 'setRetrairMenu',
    SET_ROTA_ORIGEM: 'setRotaOrigem',
    SET_ROTA_VOLTA: 'setRotaVolta',
    SET_SITUACAO_ANEXO: 'setSituacaoAnexo',
    SET_USUARIO_LOGADO: 'setUsuarioLogado',
    SET_ORGAOS_DISPONIVEIS : 'setOrgaosDisponiveis',
    SET_LOADING_LOCAL_MENSAGEM: 'setLoadingLocalMensagem',
    SET_LOADING_LOCAL_EXIBIR: 'setLoadingLocalExibir',
    SET_NOTIFICACOES_PAGE: 'setNotificacoesPage',
    NOTIFICACOES_RESET_FILTROS: 'notificacoesResetFiltros',
    SET_DEVE_ABRIR_CHAT: 'setDeveAbrirChat',
    SET_CHAT_MENSAGENS_NOTIFICACOES: 'setChatMensagensNotificacoes',
    SET_CHAT_MENSAGENS_NOTIFICACOES_PAGE:'setChatMensagensNotificacoesPage',
    SET_NOTIFICAO_PARA_LIDA: 'setNotificacaoParaLida',
    SET_NOTIFICAO_CHAT_PARA_LIDA: 'setNotificacaoChatParaLida',
    SET_CHAT_NOTIFICACOES_NAO_LIDAS: 'setChatNotificacoesNaoLidasComprador',
    SET_CHAT_NOTIFICACOES: 'setChatNotificacoes',
    SET_CHAT_CONVERSACAO_MENSAGENS: 'setChatConversacaoMensagens',
    SET_CHAT_CONVERSACAO_DESTINATARIO: 'setChatConversacaoDestinatario',
    SET_CHAT_CONVERSACAO_DETALHES_COMPRA: 'setChatConversacaoDetalhesCompra',
    SET_CHAT_DESTINATARIO_ONLINE: 'setChatDestinatarioOnline',
    SET_WEBSOCKET_SERVICE: 'setWebsocketService',
    SET_TOTAL_MENSAGENS_NAO_LIDAS_CENTRAL: 'setTotalMensagensNaoLidasCentral',
    SET_USUARIOS_ONLINE_COMPRA_DIRETA: 'setUsuariosOnlineCompraDireta',
    SET_CURRENT_TAB_CHAT: 'setCurrentTabChat',
    SET_ITEM_OU_LOTE_ATUAL_DO_CHAT: 'setItemOuLoteAtualDoChat',
    SET_CHAT_CONVERSACAO_ESTADO_INICIAL: 'setChatConversacaoEstadoInicial',
    SET_EXECUCAO_ATIVA: 'setExecucaoAtiva',
    SET_COMPRA_DIRETA_SUSPENSA: 'setCompraDiretaSuspensa',
}
